import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PetitionsInMovementQuery, PetitionsInMovementQueryVariables } from './getPetitionsInMovement.graphql';
import { PetitionsInMovement } from './getPetitionsInMovement.graphql';

export type PetitionsInMovementResponse = NonNullable<PetitionsInMovementQuery['petitionsInMovement']>;

export async function getPetitionsInMovement(
	{
		movementId,
		limit,
		offset,
	}: {
		movementId: string;
		limit: number;
		offset: number;
	},
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionsInMovementResponse> {
	const { data } = await fetch<PetitionsInMovementQuery, PetitionsInMovementQueryVariables>({
		query: PetitionsInMovement,
		variables: { id: movementId, limit, offset },
		rejectOnError: true,
	});

	if (!data.petitionsInMovement) {
		throw new Error('Error retrieving petitions in the movement');
	}
	return data.petitionsInMovement;
}
